import { CALL_API, CALL_APIS } from '.';

export default ({
  endpoint,
  authenticated,
  types,
  method,
  data,
  microservice,
  contentType,
  accept,
  headers,
  addOriginalAuthorization = false,
}) => {
  return {
    [CALL_API]: {
      endpoint,
      authenticated,
      types,
      method,
      data,
      microservice,
      contentType,
      accept,
      headers,
      addOriginalAuthorization,
    },
  };
};

export const apiConcurrentActionsCreator = (calls, types) => {
  return {
    [CALL_APIS]: {
      calls,
      types,
    },
  };
};
